import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  Button,
  Heading,
  // FormControl,
  // FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  // Select,
  useDisclosure,
} from '@chakra-ui/react';

import { setLanguage } from 'actions/formActions';
import { useAppDispatch } from 'store/configureStore';

const LanguageSwitcher = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const optionsLanguage = [
    { value: 'en', label: 'English' },
    { value: 'es', label: 'Español' },
  ];

  const handleChange = (event) => {
    const value = event.target.value;
    i18n.changeLanguage(value);
    dispatch(setLanguage(value));
    window.location.reload();
  };

  const currentLanguage = i18n.resolvedLanguage;

  return (
    <>
      <Button variant="orangeButton" onClick={onOpen}>
        <Trans>Language</Trans>
      </Button>
      <Modal size="lg" isOpen={isOpen} variant="blueScribbleModal">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading as="h2" fontSize={{ base: '3xl', lg: '5xl' }}>
              <Trans>Select a Language</Trans>
            </Heading>
            <ModalCloseButton onClick={onClose} />
          </ModalHeader>
          <ModalBody>
            <Stack spacing={2}>
              {optionsLanguage.map(({ value, label }) => (
                <Button
                  variant="blueButton"
                  key={value}
                  onClick={() => handleChange({ target: { value } })}
                  width="full"
                  fontFamily="body"
                  textTransform="none"
                  fontSize={{ base: '1.125rem', sm: '1.25rem', lg: '1.5rem' }}
                  fontWeight="500"
                  {...(currentLanguage == value && {
                    bg: 'blue.700',
                    'aria-selected': 'true',
                  })}
                  _hover={{
                    bg: 'primaryButtonColor',
                    color: 'primaryButtonTextColor',
                  }}
                >
                  {label}
                </Button>
              ))}
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
      {/* <FormControl position="relative">
        <Select
          name="select-language"
          id="select-language"
          onChange={handleChange}
          value={i18n.resolvedLanguage}
          variant="footerField"
          fontSize="sm"
        >
          {optionsLanguage.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
        <FormLabel
          htmlFor="select-language"
          position="absolute"
          color="white"
          top={0.25}
          left={4}
          fontSize="sm"
        >
          <Trans>Language</Trans>
        </FormLabel>
      </FormControl> */}
    </>
  );
};

export default LanguageSwitcher;
